'use client';

import { bindDpopKey } from '@unifyapps/network/auth/bindDpopKey';
import { useGetQueryMeta } from '@unifyapps/network/hooks/useGetQueryMeta';
import { useEffect } from 'react';

// module scope: a sessionStorage flag would outlive the page and skip the next login
let hasAttemptedThisPageLoad = false;

// binds every `_aut` session — telling anonymous from external is the endpoint's call
export function BindDpopKeyToSession({ isExternalSession }: { isExternalSession: boolean }) {
  const queryMeta = useGetQueryMeta();

  useEffect(() => {
    if (hasAttemptedThisPageLoad) return;
    hasAttemptedThisPageLoad = true;
    void bindDpopKey(queryMeta, { isExternalSession });
  }, [queryMeta, isExternalSession]);

  return null;
}
